import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { RightDrawer } from './RightDrawer';

export const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
        onRightDrawerToggle={() => setRightDrawerOpen(!rightDrawerOpen)}
      />
      
      <div className="flex">
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
        
        <main className="flex-1 min-w-0">
          {children}
        </main>
        
        <RightDrawer
          isOpen={rightDrawerOpen}
          onClose={() => setRightDrawerOpen(false)}
        />
      </div>
    </div>
  );
};
